import {z} from 'zod';

export const dlqMessagesQuerySchema = z.object({
  maxMessages: z.string().optional().default('10'),
  visibilityTimeout: z.string().optional().default('30'),
  waitTime: z.string().optional().default('0'),
});
